import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import Cookies from "js-cookie";
import { sendEvent, safeReturnTo } from "@/utils/cardnews";

const _root = "_zplabZPT";

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/full/LayoutFull.vue"),
      children: [
        { path: "/", redirect: "/login" },
        {
          path: "/login",
          component: () => import(`@/${_root}/login/LoginPage`),
          beforeEnter: (to, from, next) => {
            if (!store.getters.isAuthorized) return next();
            // 이미 로그인 상태로 로그인 페이지에 오면 목적지가 있을 때 그쪽을 우선한다
            const back = safeReturnTo(to.query.returnTo);
            return next(back || "/home");
          },
        },
        { path: "/signup", component: () => import(`@/${_root}/signUp/SignUpPage`) },
        { path: "/find_pw", component: () => import(`@/${_root}/login/FindIDPasswordPage.vue`) },
        { path: "/marketing", component: () => import(`@/${_root}/signUp/comp/agree/MarketingPage.vue`) },
        { path: "/terms", component: () => import(`@/${_root}/signUp/comp/agree/TermsPage.vue`) },
        { path: "/error/empty", component: () => import(`@/${_root}/error/ErrorPage.vue`) },
        { path: "/friends/certify", component: () => import(`@/${_root}/card/CertifyCard.vue`) },
        { path: "/friends/certify/", component: () => import(`@/${_root}/card/CertifyCard.vue`) },
        // 카드뉴스는 어드민에서 등록/발행한다. 경로는 slug 로 결정되며
        // 이미 발송된 카톡 메시지의 버튼이 이 경로를 가리키므로 형태를 바꾸면 안 된다.
        { path: "/friends/:slug", name: "카드뉴스", component: () => import(`@/${_root}/card/Card.vue`) },
      ],
    },
    {
      path: "/",
      component: () => import(`@/${_root}/Index`),
      children: [
        {
          path: "/",
          component: () => import(`@/${_root}/Pages`),
          children: [
            { path: "/home", component: () => import(`@/${_root}/home/HomePage.vue`), meta: { auth: true } },
            { path: "/userInfo", component: () => import(`@/${_root}/userInfo/UserInfo.vue`), meta: { auth: true } },
            { path: "/tempChangePassword", component: () => import(`@/${_root}/changePassword/TempChangePassword.vue`), meta: { auth: true } },
            { path: "/changePassword", component: () => import(`@/${_root}/changePassword/ChangePassword.vue`), meta: { auth: true } },
            { path: "/intro", name: "지피테라퓨틱스 소개", component: () => import(`@/${_root}/intro/IntroPage.vue`), meta: { auth: true } },
            { path: "/actinum", name: "액티넘 정보", component: () => import(`@/${_root}/actinum/ActinumPage.vue`), meta: { auth: true } },
            { path: "/lamisil", name: "라미실 정보", component: () => import(`@/${_root}/lamisil/LamisilPage.vue`), meta: { auth: true } },
            { path: "/betadine", name: "베타딘 정보", component: () => import(`@/${_root}/betadine/BetadinePage.vue`), meta: { auth: true } },
            { path: "/cyclogest", name: "사이클로제스트 정보", component: () => import(`@/${_root}/cyclogest/CyclogestPage.vue`), meta: { auth: true } },
            { path: "/mr-visit", name: "MR 방문접수", component: () => import(`@/${_root}/mrVisit/MrVisitPage.vue`), meta: { auth: true } },
          ],
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const userAgent = navigator.userAgent;

  // [비활성화] 카카오톡 외 접근 제한 (일반 브라우저 접근 허용)
  // if (!userAgent.includes("KAKAOTALK") && process.env.NODE_ENV !== "development") {
  //   alert("허용되지 않는 접근입니다");
  //   return next("/error/empty");
  // }

  const cardSlug = to.path.startsWith("/friends/") && to.params.slug ? to.params.slug : null;

  // 카드뉴스 도달(LANDING)은 인증 판단보다 먼저 기록한다.
  // 로그인 리디렉션에서 이탈하는 인원을 세려면 인증 이전에 잡아야 한다.
  // await 하지 않으므로 화면 전환이 지연되지 않는다.
  if (cardSlug) {
    sendEvent({ slug: cardSlug, eventType: "LANDING" });
  }

  // 인증 필요 시 로그인 체크
  if (to.meta.auth && !store.getters.isAuthorized) {
    return next("/login");
  }

  // 카드뉴스는 로그인 후 원래 자리로 돌아와야 한다.
  // (카드뉴스는 메뉴에 없어 직접 링크로만 접근하므로, 홈으로 보내면 다시 찾아갈 방법이 없다)
  if (cardSlug && !store.getters.isAuthorized) {
    return next({ path: "/login", query: { returnTo: to.path } });
  }

  // 클릭 로그 저장 (일반 메뉴 - to.name 있을 때만)
  if (to.name && !cardSlug) {
    try {
      const modelService = require("@/utils/dataModel.js");
      const reqDataModel = modelService.reqDataModel();

      const accessInfo = JSON.parse(Cookies.get(process.env.VUE_APP_CookieName));

      reqDataModel.endpoint = "clickLogs";
      reqDataModel.methods = "put";
      reqDataModel.log_id = 0;
      reqDataModel.user_id = accessInfo.user_id;
      reqDataModel.pageName = to.path;
      reqDataModel.content = to.name;

      await store.dispatch("saveDataQuery", reqDataModel);
    } catch (err) {
      console.error("clickLogs 저장 실패:", err);
    }
  }

  next();
});

export default router;
